import React, { useState } from "react";
import css from "./comp.module.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function SeriviceItem({ title, text, imgurl }) {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div
      className={`${css.serviceBox} ${isHovered ? css.serviceBoxHover : ""} ${
        css[imgurl]
      }`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        backgroundSize: "100% 100%",
      }}
    >
      <div
        className={`${css.serviceMask} ${
          isHovered ? css.serviceMaskHover : ""
        }`}
      ></div>

      <div
        className={`${css.serviceContent} ${
          isHovered ? css.serviceAnimation : ""
        }`}
      >
        <div
          style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "80px" }}
        >
          {t(title)}
        </div>
        <div
          className={css.textLine2}
          style={{
            fontSize: "14px",
            marginBottom: "20px",
            width: "100%",
            paddingRight: "30px",
          }}
        >
          {t(text)}
        </div>
        <div
          className={css.learnmore}
          onClick={() => navigate("/prodandsolution/solution/" + imgurl)}
        >
          {t("了解更多") + "  >"}
        </div>
      </div>

      <div
        className={`${css.whiteLine} ${isHovered ? css.whiteLineHover : ""}`}
      ></div>
    </div>
  );
}

export default React.memo(SeriviceItem);
